import { render } from "./ShopCategoryItem.vue?vue&type=template&id=a943cf3e"
import script from "./ShopCategoryItem.vue?vue&type=script&lang=js"
export * from "./ShopCategoryItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__